import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import PropTypes from 'prop-types';
import { object, string } from 'yup';
import { TextInput } from '../../../Helpers/Inputs';
import StyledRadioInput from '../../../Helpers/Inputs/StyledRadioInput';
import { NumberFormatDollars } from '../../../Helpers/Formatters';
import calendarIcon from '../../../../../src/icons/calendar1.svg';
import BasicDetails from '../../BasicDetails';
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined';
import { number as yupnumber } from "../../../Helpers/Validators/customValidators";
import BackNextButton from '../../../Common/BackNextButton';
import FormHeader from './FormHeader';

export default function CurrentInsurance(props) {
  const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
    validationSchema: CurrentInsurance.ValidationSchema,
    mode: 'onBlur',
    reValidateMode: 'onBlur'
  });

  const handleValueChange = (field, value) => {
      setValue(field, value);
      props.onFieldChange(field, value);
      triggerValidation(field);
  };

  useEffect(() => {
    register({ name: 'hasExistingPolicy' });
    setValue('hasExistingPolicy', props.formState.hasExistingPolicy);

    register({ name: 'existingLifePolicyCoverage' });
    setValue('existingLifePolicyCoverage', props.formState.existingLifePolicyCoverage);

    register({ name: 'hasExistingDIPolicy' });
    setValue('hasExistingDIPolicy', props.formState.hasExistingDIPolicy);

    register({ name: 'hasExistingLTCPolicy' });
    setValue('hasExistingLTCPolicy', props.formState.hasExistingLTCPolicy);

    register({ name: 'existingDIPolicyCoverage' });
    setValue('existingDIPolicyCoverage', props.formState.existingDIPolicyCoverage);

    register({ name: 'existingLTCPolicyCoverage' });
    setValue('existingLTCPolicyCoverage', props.formState.existingLTCPolicyCoverage);

  }, [register,props.formState.existingLifePolicyCoverage,props.formState.existingDIPolicyCoverage,props.formState.existingLTCPolicyCoverage]);

  return (
    <div>
      <Container fluid className="border-class">
    
        <Form onSubmit={handleSubmit(props.onNext)}>
        {props.StartOverButton}
        <Row className="justify-content-center pt-3 client-coverage">
            <Col lg={4}>
           <FormHeader title="Client's Current Insurance" Icon={calendarIcon} />
           <Form.Group>
                <h6>Does your client currently have a life insurance policy?</h6>
                <StyledRadioInput
                  name="hasExistingPolicy"
                  id="hasExistingPolicy"
                  value={props.formState.hasExistingPolicy}
                  options={[
                    { value: 'yes', label: 'Yes' },
                    { value: 'no', label: 'No' }
                  ]}
                  errors={errors && errors.hasExistingPolicy}
                  inputRef={register}
                  onChange={e => handleValueChange('hasExistingPolicy', e)}
                />
              </Form.Group>

              {props.formState.hasExistingPolicy === 'yes' &&
                <Form.Group>
                  <TextInput
                    name="existingLifePolicyCoverage"
                    id="existingLifePolicyCoverage"
                    label="Current coverage amount"
                    value={props.formState.existingLifePolicyCoverage}
                    errors={errors && errors.existingLifePolicyCoverage}
                    inputRef={register}
                    onChange={e => handleValueChange('existingLifePolicyCoverage', e.target.value)}
                    InputProps={{
                      inputComponent: NumberFormatDollars
                    }}
                  />
                </Form.Group>}

              <Form.Group>
                <h6>Does your client currently have a disability insurance policy?</h6>
                <StyledRadioInput
                  name="hasExistingDIPolicy"
                  id="hasExistingDIPolicy"
                  value={props.formState.hasExistingDIPolicy}
                  options={[
                    { value: 'yes', label: 'Yes' },
                    { value: 'no', label: 'No' }
                  ]}
                  errors={errors && errors.hasExistingDIPolicy}
                  inputRef={register}
                  onChange={e => handleValueChange('hasExistingDIPolicy', e)}
                />
              </Form.Group>

              {
                props.formState.hasExistingDIPolicy === 'yes' &&
                <Form.Group>
                  <TextInput
                    name="existingDIPolicyCoverage"
                    id="existingDIPolicyCoverage"
                    label="Current monthly coverage"
                    value={props.formState.existingDIPolicyCoverage}
                    errors={errors && errors.existingDIPolicyCoverage}
                    inputRef={register}
                    onChange={e => handleValueChange('existingDIPolicyCoverage', e.target.value)}
                    InputProps={{
                      inputComponent: NumberFormatDollars
                    }}
                  />
                </Form.Group>
              }

              <Form.Group>
                <h6>Does your client currently have a long-term care policy?</h6>
                <StyledRadioInput
                  name="hasExistingLTCPolicy"
                  id="hasExistingLTCPolicy"
                  value={props.formState.hasExistingLTCPolicy}
                  options={[
                    { value: 'yes', label: 'Yes' },
                    { value: 'no', label: 'No' }
                  ]}
                  errors={errors && errors.hasExistingLTCPolicy}
                  inputRef={register}
                  onChange={e => handleValueChange('hasExistingLTCPolicy', e)}
                />
              </Form.Group>
              {
                props.formState.hasExistingLTCPolicy === 'yes' &&
                <Form.Group>
                  <TextInput
                    name="existingLTCPolicyCoverage"
                    id="existingLTCPolicyCoverage"
                    label="Current monthly coverage"
                    value={props.formState.existingLTCPolicyCoverage}
                    errors={errors && errors.existingLTCPolicyCoverage}
                    inputRef={register}
                    onChange={e => handleValueChange('existingLTCPolicyCoverage', e.target.value)}
                    InputProps={{
                      inputComponent: NumberFormatDollars
                    }}
                  />
                </Form.Group>
              }
            </Col>
          </Row>
          <BackNextButton onBack={props.onBack} />
        </Form>
      </Container>
      <BasicDetails
        fullFormState={props.fullFormState}
      />
    </div>
  );
}

CurrentInsurance.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired
};

CurrentInsurance.ValidationSchema = object().shape({
  hasExistingPolicy: string().required('This field is required.'),
  hasExistingDIPolicy: string().required('This field is required.'),
  hasExistingLTCPolicy: string().required('This field is required.'),
  existingLTCPolicyCoverage: yupnumber().when('hasExistingLTCPolicy', {
    is: (hasExistingLTCPolicy) => hasExistingLTCPolicy === 'yes',
    then:  yupnumber()
    .transform(emptyStringToUndefined)
    .required("This field is required.")
    .min(1, 'Amount must be greater than or equal to $1.')
    .max(9999999999, "Amount must be less than or equal to $9,999,999,999."),
    otherwise:   yupnumber().nullable()
    .transform(emptyStringToUndefined)
    .notRequired(),
  }),
  existingDIPolicyCoverage: yupnumber().when('hasExistingDIPolicy', {
    is: (hasExistingDIPolicy) => hasExistingDIPolicy === 'yes',
    then:  yupnumber()
    .transform(emptyStringToUndefined)
    .required("This field is required.")
    .min(1, 'Amount must be greater than or equal to $1.')
    .max(9999999999, "Amount must be less than or equal to $9,999,999,999."),
    otherwise:   yupnumber().nullable()
    .transform(emptyStringToUndefined)
    .notRequired(),
  }),
  existingLifePolicyCoverage: yupnumber().when('hasExistingPolicy', {
    is: (hasExistingPolicy) => hasExistingPolicy === 'yes',
    then:  yupnumber()
    .transform(emptyStringToUndefined)
    .required("This field is required.")
    .min(1, 'Amount must be greater than or equal to $1.')
    .max(9999999999, "Amount must be less than or equal to $9,999,999,999."),
    otherwise:   yupnumber().nullable()
    .transform(emptyStringToUndefined)
    .notRequired(),
  }),
});

CurrentInsurance.DefaultFormState = (prefill = false) => {
  return {
    hasExistingPolicy: prefill ? 'yes' : '',
    existingLifePolicyCoverage: prefill ? '150000' : '',
    hasExistingDIPolicy: prefill ? 'no' : '',
    hasExistingLTCPolicy: prefill ? 'no' : '',
    existingDIPolicyCoverage: prefill ? '150000' : '',
    existingLTCPolicyCoverage: prefill ? '15000' : '',
  };
};



// WEBPACK FOOTER //
// ./src/components/InsuranceTools/NeedsAnalysis/steps/CurrentInsurance.js